import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  primaryButton: theme.classes.mainButton,
  secondaryButton: theme.classes.secondaryButton,
}));

const CustomConfirmationDialog = ({
  open,
  title,
  text,
  handleClose,
  acceptText = "ra.action.accept",
  cancelText = "ra.action.cancel",
  handleAccept,
}) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={classes.secondaryButton} onClick={() => handleClose()} color="primary">
          {intl.formatMessage({ id: cancelText })}
        </Button>
        {handleAccept && (
          <Button className={classes.primaryButton} onClick={handleAccept} color="primary" autoFocus>
            {intl.formatMessage({ id: acceptText })}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomConfirmationDialog;
